import {
    Box,
    DialogActions,
    DialogContent,
    DialogTitle,
    Slide,
    Stack,
    Typography,
    useTheme,
} from "@mui/material"
import { ReactElement } from "react"

import { ReactComponent as CarSvg } from "../../../assets/kpi-three.svg"
import { SLIDE_IN_TIMEOUT } from "../../../constants/generalConstants"
import DisplayIf from "../../wrappers/displayIf"

interface IFullScreenTitleContent {
    titlePrimaryColor?: string
    titleMain?: string
    subtitle: string
    content: ReactElement
    actionContent?: ReactElement
    customSvg?: ReactElement
    animateSvg?: boolean
}

const FullScreenTitleContent = ({
    titlePrimaryColor,
    titleMain,
    subtitle,
    content,
    actionContent,
    customSvg,
    animateSvg,
}: IFullScreenTitleContent): ReactElement => {
    const theme = useTheme()
    return (
        <Box display="flex" height="100%">
            <Box
                display={{ xs: "none", lg: "flex" }}
                flexDirection="column"
                width={{ lg: "55%", xl: "60%" }}
                height="100vh"
            >
                <Slide
                    direction="up"
                    in
                    mountOnEnter
                    unmountOnExit
                    timeout={animateSvg ? SLIDE_IN_TIMEOUT : 0}
                >
                    <Box
                        width="100%"
                        height="100vh"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            padding: { lg: 10, xl: 20 },
                        }}
                    >
                        {customSvg || (
                            <CarSvg width="100%" viewBox="680 340 1100 600" />
                        )}
                    </Box>
                </Slide>
            </Box>
            <Box
                display="flex"
                flexDirection="column"
                width={{ xs: "100%", lg: "45%", xl: "40%" }}
                padding={{ xs: 0, md: 2 }}
            >
                <DialogTitle sx={{ paddingX: 0 }}>
                    <Typography
                        paddingTop={titleMain ? 6 : 0}
                        align="center"
                        color={theme.palette.text.primary}
                        variant="h3"
                        component="div"
                        display={{
                            display:
                                titlePrimaryColor || titleMain
                                    ? undefined
                                    : "none",
                        }}
                    >
                        <Box
                            color={theme.palette.primary.main}
                            display="inline"
                        >
                            {titlePrimaryColor}
                        </Box>
                        {titleMain}
                    </Typography>
                </DialogTitle>
                <DialogContent
                    sx={{
                        marginTop: titleMain ? 5 : 0,
                        flexGrow: 1,
                        paddingX: 0,
                    }}
                >
                    <Stack spacing={4} height="100%">
                        <Typography
                            variant="h6"
                            color="text.secondary"
                            fontWeight={400}
                            sx={{ display: subtitle ? undefined : "none" }}
                        >
                            {subtitle}
                        </Typography>
                        {content}
                    </Stack>
                </DialogContent>
                <DisplayIf condition={!!actionContent}>
                    <DialogActions sx={{ p: 0, pb: 3, pt: 2, flexGrow: 0 }}>
                        {actionContent}
                    </DialogActions>
                </DisplayIf>
            </Box>
        </Box>
    )
}

FullScreenTitleContent.defaultProps = {
    actionContent: null,
    customSvg: null,
    animateSvg: false,
    titlePrimaryColor: undefined,
    titleMain: undefined,
}

export default FullScreenTitleContent
